import { SerializedStyles } from "@emotion/react";
import { Ref, memo, useCallback } from "react";
import { usePartialSubmit } from "src/apps/AppFlow/pages/hooks";
import { FormFlowPage } from "src/components";
import DropdownSelector from "src/components/DropdownSelector";

import { enums, formatters } from "@fraction/shared";

const { RESIDENCY_STATUS_MAP } = formatters.enums;

export interface ResidencyStatusUSProps {
  onChange: (value: enums.ResidencyStatus) => void;
  value?: enums.ResidencyStatus;
  title?: string;

  focusRef?: Ref<HTMLInputElement>;
  onNext: () => void;
  onBack: () => void;
  style?: SerializedStyles;
}

const ResidencyStatusUS = ({
  onNext,
  onBack,
  style,
  focusRef,
  value,
  onChange,
  title,
  ...props
}: ResidencyStatusUSProps) => {
  const validate = useCallback(() => !!value, [value]);
  const { handleNext, nextDisabled, nextLoading } = usePartialSubmit({ onNext, validate });

  return (
    <FormFlowPage
      {...props}
      title={title || "What's your residency status?"}
      description="Fraction can lend to citizens, permanent residents, and some non-permanent residents."
      onNext={handleNext}
      onBack={onBack}
      style={style}
      nextDisabled={nextDisabled}
      nextLoading={nextLoading}
    >
      <DropdownSelector
        label="Residency status"
        focusRef={focusRef}
        value={value}
        onChange={onChange}
        options={Object.values(enums.ResidencyStatus)
          .filter((val) => val.slice(0, 2) === "us")
          .map((type) => ({
            value: type,
            label: RESIDENCY_STATUS_MAP[type],
          }))}
      />
    </FormFlowPage>
  );
};

export default memo(ResidencyStatusUS);
